// Рабочее место логиста: /api/v2/workspace/* (erp-backend, модуль src/workspace).
import { useAxiosCreate } from '@/backend/utils.js'

const api = useAxiosCreate('api')

export async function fetchWorkspaceSummary(scope = 'all') {
  const { data } = await api.get('workspace/summary', { params: { scope } })
  return data
}

// Приём рейсов из TMS: плашка сверху всех экранов, если рейсы не поступают (решение Анны 02.11.2026).
export async function fetchTmsIntake() {
  const { data } = await api.get('workspace/intake')
  return data
}

export async function fetchWorkspaceHealth() {
  const { data } = await api.get('workspace/health')
  return data
}

export async function whereIsTrip(number) {
  const { data } = await api.get('workspace/where', { params: { number } })
  return data
}

// «Показатели группы» — analytics-service через прокси статистики erp-backend.
export async function fetchTeamGoals(month) {
  const { data } = await api.get('statistics/team-goals', { params: month ? { month } : {} })
  return data
}

// «Показатели группы» видит только руководитель логистики — сервер отвечает {allowed}.
export async function fetchTeamGoalsAccess() {
  const { data } = await api.get('workspace/team-goals/access')
  return Boolean(data && data.allowed)
}

// Глобус «Рейсы в пути»: рейсы в статусе «В пути» с городами (erp-backend src/workspace/geo.py).
export async function fetchWorkspaceGlobe(scope = 'all') {
  const { data } = await api.get('workspace/globe', { params: { scope } })
  return data
}

// Светофор: «Техническое состояние» и «Светофор логиста» (erp-backend src/lights, решение Анны 03.11.2026).
export async function fetchWorkspaceLights(scope = 'all') {
  const { data } = await api.get('workspace/lights', { params: { scope } })
  return data
}
